export default {
  radius: {
    none: 0,
    small: 8,
    regular: 16,
    medium: 24,
    infinite: 10000000000,
    large: 32,
    tiny: 4,
    custom: 20,
  },
  itemSize: {
    small: 8,
    tiny: 4,
    'x-small': 12,
    regular: 16,
    medium: 24,
    large: 32,
    largeish: 40,
    'x-large': 48,
    'xx-large': 52,
    'imageSize': 95,
    '4xl': 88,
  },
  stroke: {
    tiny: 0.5,
    small: 1,
    regular: 2,
  },
  iconSize: {
    base: 24,
    iconMedium: 18,
  },
  'chat-bubble': {
    undefined: 14,
  },
}
